module.exports = __webpack_public_path__ + "static/media/accounts_employees_add.b93e1987.svg";